import { Wind } from "lucide-react";

export default function AcTypeSelector({ label, value, options, onChange }) {
  return (
    <div>
      <label className="label-eyebrow flex items-center gap-2 mb-3">
        <Wind className="w-4 h-4" />
        {label}
      </label>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {Object.entries(options).map(([key, optLabel]) => (
          <button
            type="button"
            key={key}
            data-testid={`booking-actype-${key}`}
            onClick={() => onChange(key)}
            className={`radio-card ${value === key ? "active" : ""}`}
          >
            <span className="dot" />
            {optLabel}
          </button>
        ))}
      </div>
    </div>
  );
}
